import { render } from "./CameraScreenshot.vue?vue&type=template&id=4f926a0a&ts=true"
import script from "./CameraScreenshot.vue?vue&type=script&lang=ts"
export * from "./CameraScreenshot.vue?vue&type=script&lang=ts"

import "./CameraScreenshot.vue?vue&type=style&index=0&id=4f926a0a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__